export const COMPANY = {
  name: "BIK COMMOTRADE (OPC) PVT LTD",
  shortName: "BIK COMMOTRADE",
  tagline: "WHERE POWER MEETS PRECISION",
  secondaryTagline: "Powering Tomorrow Today",
  established: 2021,
  // Official company logo (uploaded by owner). Set `src` to null to fall back to the built-in SVG mark.
  logo: { src: "/logo.png", alt: "BIK COMMOTRADE (OPC) PVT LTD — logo" },
  // Director portrait (uploaded by owner). Set `src` to null to fall back to the placeholder.
  director: {
    name: "Bhaskar Basu",
    role: "Director",
    portrait: { src: "/director.jpeg", alt: "Portrait of Bhaskar Basu, Director" },
    signature: { src: null, alt: "Signature of Bhaskar Basu" },
  },
  nav: [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    { label: "Products", path: "/products" },
    { label: "Certifications", path: "/certifications" },
    { label: "Director's Message", path: "/directors-message" },
    { label: "Careers", path: "/careers" },
    { label: "Contact", path: "/contact" },
  ],
  office: {
    label: "Office Address",
    lines: ["97/1 Kazipara, Baidyabati,", "Hooghly, West Bengal – 712222"],
  },
  manufacturing: {
    label: "Manufacturing Unit",
    lines: [
      "Chhinamore, Laha Road, Radhakunj,",
      "Beside Baidyabati–Tarakeswar Road,",
      "West Bengal – 712223",
    ],
  },
  emails: ["bhaskarbasu2@gmail.com", "bikcomotrade@gmail.com"],
  phones: [
    { display: "+91 98308 29512", link: "+919830829512" },
    { display: "+91 87776 95545", link: "+918777695545" },
  ],
  whatsapp: "919830829512",
  socials: [
    { name: "LinkedIn", url: "#" },
    { name: "X", url: "#" },
    { name: "Facebook", url: "#" },
    { name: "YouTube", url: "#" },
  ],
  copyright: "© 2026 BIK COMMOTRADE (OPC) PVT LTD. All Rights Reserved.",
};

// Railway ecosystem marquee. CLW is shown as a railway organisation reference only —
// it does not imply a contractual relationship. Replace / extend these entries freely.
export const ECOSYSTEM_MARQUEE = [
  "CLW — Chittaranjan Locomotive Works",
  "Railway Electrical",
  "Electromechanical Components",
  "Traction & Earthing",
  "Coach Lighting",
  "Pipe Fittings",
  "Precision Engineering",
  "Quality Driven Manufacturing",
];
